module.exports = __webpack_public_path__ + "static/media/squadIcons.a358c6c8.svg";